import { TranslatedText, translatedTextSchema } from "../core/TranslatedText";
import * as zod from "zod";

export interface ProjectType {
  id: number;
  isDefault: boolean;
  translations: TranslatedText[];
}

export const projectTypeSchema = zod.object({
  id: zod.number().nonnegative(),
  isDefault: zod.boolean(),
  translations: zod.array(translatedTextSchema),
});
